import { render } from "./EditorBoxSizing.vue?vue&type=template&id=6b868ffb&scoped=true"
import script from "./EditorBoxSizing.vue?vue&type=script&lang=js"
export * from "./EditorBoxSizing.vue?vue&type=script&lang=js"

import "./EditorBoxSizing.vue?vue&type=style&index=0&id=6b868ffb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6b868ffb"

export default script